import { render } from "./HeadVue.vue?vue&type=template&id=08bffbc6"
import script from "./HeadVue.vue?vue&type=script&lang=js"
export * from "./HeadVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LCE\\Documents\\code\\front-end LCE\\prudentialBelife\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__